<template>
  <BaseButton theme="default"
              :class="{'pointer-events-none':exporting_space}"
              @click="exportTransactions">
      <span class="flex items-center justify-center" v-if="!exporting_space">
        <font-awesome-icon icon="file-download" class="text-icon"/>
        <span class="ml-4 text-sm font-medium">{{ $t('exportTransactions') }}</span>
      </span>
    <font-awesome-icon v-else icon="circle-notch" spin/>
  </BaseButton>
</template>

<script>
import {mapActions} from "vuex";
import BaseButton from "@/components/UI/BaseButton";

export default {
  name: "SpaceExportTransactions",
  components: {BaseButton},
  data() {
    return {
      exporting_space: false
    }
  },
  methods: {
    ...mapActions('space', ['exportSpaceTransactions']),
    async exportTransactions() {
      this.exporting_space = true
      const res = await this.exportSpaceTransactions()
      // console.log(res.data)
      const url = window.URL.createObjectURL(new Blob([
            new Uint8Array([0xEF, 0xBB, 0xBF]), // UTF-8 BOM
            res.data],
          {type: 'text/csv;charset=utf-8-with-bom'}))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `${this.$store.state.space.current_space.data.title}_${this.$moment().unix()}.csv`)
      document.body.appendChild(link)
      link.click()
      link.remove()
      this.exporting_space = false
    }
  },
  i18n: {
    messages: {
      en: {
        exportTransactions: 'Transactions export'
      },
      ru: {
        exportTransactions: 'Экспорт транзакций'
      }
    }
  }
}
</script>